/* eslint-disable no-param-reassign */

// Third party
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

// Reducer
import authReducer from "./Reducers/AuthModule/auth";
import reviewReducer from "./Reducers/review";
import planningReducer from "./Reducers/planning";
import feedbackReducer from "./Reducers/feedback";
import generalSettingsReducer from "./Reducers/generalSettings";
import globalFiltersReducers from "./Reducers/globalFilters";
import inviteUserReducer from "./Reducers/inviteUser";
import sideMenuBarReducer from "./Reducers/sideMenuBar";
import actionReducer from "./Reducers/actions";
import masterDataReducer from "./Reducers/masterData";

import { setNumberLocale } from "../Library/numberLocale";

const appReducer = combineReducers({
  inviteUserReducer,
  authReducer,
  reviewReducer,
  planningReducer,
  feedbackReducer,
  generalSettingsReducer,
  globalFiltersReducers,
  actionReducer,
  sideMenuBarReducer,
  masterDataReducer});

// root reducer that resets state on logout
const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: any
) => {
  if (action.type === "LOGOUT") {
    state = undefined; // clears the entire redux store
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer});

// Formatting helpers read the number format without a hook.
store.subscribe(() =>
  setNumberLocale(store.getState().generalSettingsReducer.numberFormat)
);

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
